import { useMemo } from 'react';

import { useLineMessageStore } from '../store';

import { ButtonTypeBlock } from './button-type-block';
import { ImageTypeBlock } from './ImageTypeBlock';
import { ImageVideoBlock } from './ImageVideoBlock';
import { PlainTextBlock } from './PlainTextBlock';
import { RichMessageBlock } from './RichMessageBlock';

export * from './MessageBlocks';

export const useFormViewTemplate = () => {
  const view = useLineMessageStore((state) => state.view);

  return useMemo(() => {
    if (view.name === 'PLAIN_TEXT') return PlainTextBlock.bind(null, { view });
    if (view.name === 'RICH') return RichMessageBlock.bind(null, { view });
    if (view.name === 'BUTTON') return ButtonTypeBlock.bind(null, { view });
    if (view.name === 'IMAGES') return ImageTypeBlock.bind(null, { view });
    if (view.name === 'IMAGE_VIDEO') return ImageVideoBlock.bind(null);

    return undefined;
  }, [view]);
};
